import { Stack, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import * as React from "react";
import ActiveScenarios from "../ParticipantProfile/components/ActiveScenarios";

const ActiveScenariosCard = ({ item }) => {
  const navigate = useNavigate();

  // ✅ Mock Data
  const mockDataCard = {
    id: 1,
    name: "SQL Injection",
    severity: "Medium",
    points: 3,
    thumbnail_url:
      "https://images.unsplash.com/photo-1555949963-aa79dcee981c",
    description:
      "Exploit a vulnerable database to bypass vulnerable database to bypass database...",
  };

  const scenario = item?.scenario || mockDataCard;

  return (
    <Stack
      direction="row"
      sx={{
        width: "100%",
        gap: 3,
        p: 2.5,
        borderRadius: "18px",
        background: "linear-gradient(145deg, #1E222D, #171A22)",
        border: "1px solid rgba(255,255,255,0.05)",

        boxShadow: `
          0px 10px 30px rgba(0,0,0,0.6),
          inset 0px 1px 0px rgba(255,255,255,0.05)
        `,

        cursor: "pointer",
        transition: "all 0.3s ease",

        "&:hover": {
          transform: "translateY(-3px)",
          boxShadow: `
            0px 15px 40px rgba(0,0,0,0.8),
            0px 0px 0px 1px rgba(8,190,208,0.4),
            inset 0px 1px 0px rgba(255,255,255,0.08)
          `,
        },
      }}
      onClick={() => navigate(`/scenarios/details/${scenario?.id}`)}
    >
      {/* Image */}
      <img
        src={scenario?.thumbnail_url}
        alt="scenario"
        style={{
          width: "130px",
          height: "130px",
          borderRadius: "16px",
          objectFit: "cover",
        }}
      />

      {/* Content */}
      <Stack justifyContent="space-between" sx={{ flex: 1 }}>

        {/* Title + Badges */}
        <Stack gap={1.2}>
          <Typography
            sx={{
              color: "#E6E8EC",
              fontSize: "20px",
              fontWeight: 500,
            }}
          >
            {scenario?.name}
          </Typography>

          <Stack direction="row" gap={1}>
            <Badge text="Corporate" />
            <Badge text={scenario?.severity} />
            <Badge text={`${scenario?.points} points`} />
          </Stack>
        </Stack>

        {/* Description */}
        <Typography
          sx={{
            color: "#9CA3AF",
            fontSize: "14px",
            lineHeight: 1.6,
            mt: 1,
            maxWidth: "90%",
          }}
        >
          {scenario?.description
            ?.replace(/(<([^>]+)>)/gi, "")
            ?.substring(0, 120)}
        </Typography>

        {/* Resume */}
        <Typography
          sx={{
            color: "#10D1DB",
            fontSize: "15px",
            mt: 1.2,
            display: "flex",
            alignItems: "center",
            gap: "6px",
            fontWeight: 500,
          }}
        >
          Resume ↗
        </Typography>
      </Stack>
    </Stack>
  );
};


//  Badge Component 
const Badge = ({ text }) => (
  <Typography
    sx={{
      color: "#A1A1AA",
      fontSize: "12px",
      px: 1.6,
      py: 0.6,
      borderRadius: "10px",

      background: "#11141B",
      border: "1px solid rgba(255,255,255,0.06)",

      //  depth effect
      boxShadow: `
        inset 0px 1px 0px rgba(255,255,255,0.06),
        0px 2px 6px rgba(0,0,0,0.4)
      `,
    }}
  >
    {text}
  </Typography>
);

export default ActiveScenariosCard;